import React from "react"
import {
	Assignee,
	AssignmentStage,
	AssignmentStatus,
	DrawdownAuthorizationReviewAssignmentItemPayload,
} from "../../resources/assignments"
import {WirePayment} from "../../resources/payment"
import {Customer} from "../../resources/customer"
import {BusinessApplication} from "../../resources/application"
import {Claims} from "../../services/auth"
import {Account} from "../../resources/account"
import {AssignmentPageItemDrawdownAuthorizationReviewView} from "./AssignmentPageItemDrawdownAuthorizationReviewView"
import {useAsyncResult} from "../../hooks/useAsyncResult"
import {getPaymentAuthorizationRuleDocumentUrl} from "../../resources/paymentAuthorizationRule"
import {AsyncResultComponent} from "../../containers/AsyncResult/AsyncResult"

interface AssignmentPageItemDrawdownAuthorizationReviewViewProps {
	id: string
	assignees: Assignee[]
	status: AssignmentStatus
	stage: AssignmentStage
	title: string
	description?: string | JSX.Element
	createdAt: Date
	statusUpdatedAt?: Date
	isOwnersItem?: boolean
	wire: WirePayment
	account?: Account
	customer?: Customer
	wireDrawdownCreationDate?: Date
	businessApplication?: BusinessApplication
	payload: DrawdownAuthorizationReviewAssignmentItemPayload
	accessToken: string
	refresh: () => void
	disabled?: boolean
	claims?: Claims
}

export enum DrawdownAuthorizationReviewStatusUpdateReasonKeys {
	SuspectedFraud = "SuspectedFraud",
	ClientRequest = "ClientRequest",
	InsufficientFunds = "InsufficientFunds",
	InvalidName = "InvalidName",
	InvalidRoutingNumber = "InvalidRoutingNumber",
	Other = "Other",
}

export function AssignmentPageItemDrawdownAuthorizationReview({
	id,
	assignees,
	status,
	stage,
	title,
	description,
	createdAt,
	statusUpdatedAt,
	isOwnersItem,
	wire,
	account,
	customer,
	wireDrawdownCreationDate,
	businessApplication,
	payload,
	accessToken,
	refresh,
	disabled,
	claims,
}: AssignmentPageItemDrawdownAuthorizationReviewViewProps) {
	const paymentAuthorizationRuleId = wire.relationships?.paymentAuthorizationRule?.data.id

	if (!paymentAuthorizationRuleId) {
		return <div style={{padding: "16px"}}>No payment authorization rule found for this payment,</div>
	}

	const resultReq = useAsyncResult(
		() => getPaymentAuthorizationRuleDocumentUrl(accessToken, paymentAuthorizationRuleId),
		[refresh]
	)

	return (
		<AsyncResultComponent asyncResult={resultReq}>
			{({value: paymentAuthorizationRuleDocumentUrl}) => {
				return (
					<AssignmentPageItemDrawdownAuthorizationReviewView
						id={id}
						assignees={assignees}
						status={status}
						stage={stage}
						title={title}
						description={description}
						createdAt={createdAt}
						statusUpdatedAt={statusUpdatedAt}
						isOwnersItem={isOwnersItem}
						wire={wire}
						account={account}
						customer={customer}
						businessApplication={businessApplication}
						payload={payload}
						accessToken={accessToken}
						refresh={refresh}
						disabled={disabled}
						claims={claims}
						paymentAuthorizationRuleDocumentUrl={paymentAuthorizationRuleDocumentUrl.data.attributes.url}
						wireDrawdownCreationDate={wireDrawdownCreationDate}
					/>
				)
			}}
		</AsyncResultComponent>
	)
}
